import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logoWhite from '../../images/Logo_White.png';
import './Header.css';

const Header = ({ userInfo, onLogout, compact = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isDashboardActive = location.pathname === '/dashboard';
  const isReadingActive = location.pathname === '/reading' || location.pathname === '/home';
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigateTo = (path) => {
    setIsMenuOpen(false);
    navigate(path);
  };

  return (
    <div className={`header ${compact ? 'header-compact' : ''}`}>
      <img src={logoWhite} alt="ReadSphere Banner" className={`header-logo ${compact ? 'header-logo-compact' : ''}`} />
      {!compact && (
        <>
        <button
          className="header-menu-btn"
          type="button"
          aria-expanded={isMenuOpen}
          aria-controls="primary-navigation"
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span aria-hidden="true">☰</span>
          <span>Menu</span>
        </button>
        <div id="primary-navigation" className={`header-nav ${isMenuOpen ? 'open' : ''}`}>
          <button className={`header-nav-btn ${isDashboardActive ? 'active' : ''}`} onClick={() => navigateTo('/dashboard')}>
            <img src="/header/dashboard.png" alt="Dashboard" className="header-nav-icon" />
            Dashboard
          </button>
          <button className={`header-nav-btn ${isReadingActive ? 'active' : ''}`} onClick={() => navigateTo('/reading')}>
            <img src="/header/reading.png" alt="Reading List" className="header-nav-icon" />
            Reading List
          </button>
        </div>
        </>
      )}
      <div className="header-userbar">
        <span className="header-useremail">{userInfo?.email || ''}</span>
        {userInfo?.cefr_level && (
          <span className="header-usercefr">CEFR: {userInfo.cefr_level}</span>
        )}
        <button className="header-logout-btn" onClick={onLogout}>Logout</button>
      </div>
    </div>
  );
};

export default Header;
